import React, { useCallback, useEffect } from 'react'

// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
function isDisplayed<T extends HTMLElement>(element: T): boolean {
  return null !== element.offsetParent
}

export function useOutsideHandler<T extends HTMLElement>(
  ref: React.RefObject<T | null>,
  callback: (event: Event) => void
): void {
  const clickHandler = useCallback(
    (event: Event) => {
      const target = event.target as T
      const element = ref.current
      if (null !== element && isDisplayed(element) && !element.contains(target)) {
        callback(event)
      }
    },
    [ref, callback]
  )

  useEffect(() => {
    document.addEventListener('click', clickHandler)
    return () => {
      document.removeEventListener('click', clickHandler)
    }
  }, [clickHandler])
}
